import type { BootstrapPayload } from "../../shared/contracts/bootstrap.js";

export async function loadBootstrap(): Promise<BootstrapPayload> {
  const response = await fetch("/api/v1/bootstrap", {
    credentials: "include",
    headers: { accept: "application/json" },
  });
  if (!response.ok) {
    throw new Error("The account could not load.");
  }
  return response.json();
}
